import { cloneDeep } from 'lodash/lang'
import { selectDefaultProduct } from 'lib/cart/services/selection'

// Select a default product if needed for the given camper and session
const setCartProductDefault = (state, action) => {
  const { camper, session, camperSession, product } = action

  // clone cart products so we don't mutate state
  const cartForm = cloneDeep(state)

  // select a default product if needed
  selectDefaultProduct(product, { session, camper, camperSession, cartForm })

  // return a new state object
  return cartForm
}

export default setCartProductDefault
